enum OntarioObstetricalFilePageIdEnum {
    Opr1,
    Opr2,
    Opr3,
    Resources,
    WeightGainChart,
    PostNatal
}

export { OntarioObstetricalFilePageIdEnum };
